<h2 class="title" mat-dialog-title>{{data.dialogTitle}}</h2>
<div mat-dialog-content>
  <p>{{data.dialogRow1}}</p>
   <p>{{data.dialogRow2}}</p>
</div>
<div mat-dialog-actions class="buttonsHolder">
  <button class="cancelButton" mat-button (click)="onNoClick()">Cancel</button>
  <button class="confirmButton" mat-button (click)="onConfirm()">Refresh</button>
</div>
